module.exports = __webpack_public_path__ + "static/media/tablet_icon.27e06d53.png";